import { lazy } from 'react';
import SignUpModal from '../auth/Login/SignUp';
import SignUpView from '../auth/Login/SignUpView';

// Authorization Components
const OnboardInvestor = lazy(() =>
  import('../auth/AdminOnboarding/OnboardInvestor')
);
const Login = lazy(() => import('../auth/Login/Login'));
const LoginView = lazy(() => import('../auth/Login/LoginView'));
const KYCOnboardInvestor = lazy(() => import('../auth/KYC/KYCOnboardInvestor'));
const ResetPassword = lazy(() => import('../auth/Login/ResetPassword'));
const VerifyLoginOTP = lazy(() => import('../auth/Login/VerifyOTP'));
const VerifyOtpView = lazy(() => import('../auth/Login/VerifyOtpView'));
const KYCVerifyOTP = lazy(() => import('../auth/KYC/KYCVerifyOTP'));
const ForgotPassword = lazy(() => import('../auth/Login/ForgotPassword'));
const ForgotPasswordView = lazy(() => import('../auth/Login/ForgotPasswordView'));
const EmailConfirmation = lazy(() => import('../auth/EmailConfirmation'));
const ApiDocsView = lazy(() => import('../pages/ApiDocs'));

export const nonProtectedRoutes = [
  {
    path: '/login',
    component: LoginView,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/sign-up',
    component: SignUpView,
    // component: SignUpModal,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/verify-otp',
    component: VerifyOtpView,
    // component: VerifyLoginOTP,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/verify-registration-otps',
    component: KYCVerifyOTP,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/forgot-password',
    component: ForgotPasswordView,
    // component: ForgotPassword,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/register',
    component: KYCOnboardInvestor,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/onboard-investor',
    component: OnboardInvestor,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/confirm-email',
    component: EmailConfirmation,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/verify-email',
    component: EmailConfirmation,
    hiddenInSidebar: true,
    exact: true,
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    hiddenInSidebar: true,
    exact: true,
  },

  // --------------- API Docs ------------------ //
  {
    path: '/docs',
    component: ApiDocsView,
    hiddenInSidebar: true,
    exact: true,
  },

  // ----------------------------------------- //
];
